import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const EntityLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    code: '',
    password: '',
    mobileNumber: '' // ADDED: For reset password
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Create test Entity for development
  const createTestEntity = async () => {
    try {
      setIsLoading(true);
      setError('');
      setSuccessMessage('');

      const testEntity = {
        name: 'د. أحمد محمد',
        email: 'test.Entity@example.com',
        password: 'test123',
        phone: '01234567890',
        specialization: 'باطنة',
        experience_years: 5,
        consultation_fee: 200
      };

      const response = await fetch(process.env.REACT_APP_API_BASE_URL+'/api/entity/register', {
        method: 'POST',
        headers: {
                   'Content-Type': 'application/json',
          'Accept': 'application/json'  // Add this`
        },
        body: JSON.stringify(testEntity),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage(`تم إنشاء ال إدارة التجريبي بنجاح! الكود: ${data.EntityCode}`);
        setFormData({
          code: data.EntityCode,
          password: 'test123'
        });
      } else {
        if (response.status === 400 && data.message.includes('مسجل بالفعل')) {
          setError('ال إدارة التجريبي موجود بالفعل - جرب تسجيل الدخول بكلمة المرور: test123');
        } else {
          setError(data.message || 'حدث خطأ في إنشاء ال إدارة التجريبي');
        }
      }
    } catch (err) {
      console.error('Error creating test Entity:', err);
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // For code field, convert to uppercase and only allow alphanumeric
  
      setFormData({
        ...formData,
        [name]: value
      });
     
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      // Validate input
      if (!formData.mobileNumber || !formData.password) {
        setError('الرجاء إدخال رقم الهاتف وكلمة المرور');
        setIsLoading(false);
        return;
      }

  
      console.log(process.env.REACT_APP_API_BASE_URL+'/api/Entity/login'); 

       
      const response = await fetch(process.env.REACT_APP_API_BASE_URL+'/api/Entity/login', {
        method: 'POST',
        headers: {
                   'Content-Type': 'application/json',
          'Accept': 'application/json'  // Add this`
          
        },
        body: JSON.stringify({
          mobileNumber: formData.mobileNumber,
          password: formData.password
        }),
      });

      const data = await response.json();

      if (response.ok) {
        // ADD: Log the received data to debug TokenA structure
        console.log('Login response data:', data);
        console.log('TokenA received:', data.tokenA);
        console.log('Entity data received:', data.entity);
        
        // MODIFIED: Decode and log the JWT TokenA to verify its contents
        if (data.tokenA) {
          try {
            // Decode JWT payload (note: this doesn't verify signature, just decodes)
            const base64Url = data.tokenA.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            const decodedTokenA = JSON.parse(jsonPayload);
            console.log('Decoded JWT payload:', decodedTokenA);
            
            // ADDED: Check if the TokenA has the expected fields
            if (!decodedTokenA.userId && !decodedTokenA.EntityId && !decodedTokenA.id) {
              console.warn('Warning: TokenA does not contain userId, EntityId, or id field');
              console.warn('Available fields in TokenA:', Object.keys(decodedTokenA));
            }
            
            if (!decodedTokenA.userType && !decodedTokenA.role && !decodedTokenA.type) {
              console.warn('Warning: TokenA does not contain userType, role, or type field');
            }
          } catch (decodeError) {
            console.error('Error decoding JWT TokenA:', decodeError);
          }
        }
        
        // Store the TokenA and Entity data in localStorage
        localStorage.setItem('EntityTokenA', data.tokenA);
        localStorage.setItem('EntityData', JSON.stringify(data.entity));
        
        // ADDED: Store additional fields for debugging
        localStorage.setItem('userType', 'Entity');
        localStorage.setItem('userId', data.entity?.id || data.entity?.Entity_id);
        
        // Log success for debugging
        console.log('Login successful:', data.message);
        console.log('Entity data:', data.entity);
        console.log('Stored in localStorage:', {
          TokenA: localStorage.getItem('EntityTokenA'),
          EntityData: localStorage.getItem('EntityData'),
          userType: localStorage.getItem('userType'),
          userId: localStorage.getItem('userId')
        });
        
        // Navigate to dashboard
        navigate('/Entity/dashboard');
      } else {
        // Handle specific error cases
        if (response.status === 401) {
          setError(data.message || 'الكود أو كلمة المرور غير صحيحة - تأكد من صحة البيانات');
        } else if (response.status === 400) {
          setError(data.message || 'بيانات غير صحيحة');
        } else {
          setError(data.message || 'حدث خطأ في تسجيل الدخول');
        }
        
        // Log error details for debugging
        console.error('Login failed:', {
          status: response.status,
          message: data.message,
          code: formData.code.toUpperCase()
        });
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('حدث خطأ في الاتصال بالخادم - تأكد من تشغيل الخادم على المنفذ  ');
    } finally {
      setIsLoading(false);
    }
  };

    const handleResetPassword = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setSuccessMessage(''); // ADDED: Clear success message

    if (!formData.mobileNumber) {
      setError('يرجى إدخال رقم الموبايل لإعادة تعيين كلمة المرور');
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL+'/api/Auth/doc-reset-password', {
        method: 'POST',
        headers: {
                   'Content-Type': 'application/json',
          'Accept': 'application/json'  // Add this`
        },
        body: JSON.stringify({
          mobileNumber: formData.mobileNumber
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage('تم إرسال رابط إعادة تعيين كلمة المرور إلى حساب التليجرام الخاص بك إذا كان مسجلاً لدينا.');
      } else {
        setError(data.message || 'حدث خطأ في إرسال رابط إعادة التعيين');
      }
    } catch (err) {
      console.error('Reset password error:', err);
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
      setIsLoading(false);
    }
  };

    const botUsername = 'Reservation_ASASM_B1Bot'; // Replace with your bot username
  const telegramBotUrl = `https://t.me/${botUsername}`;

  const handleOpenBot = () => {
    window.open(telegramBotUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 via-blue-600 to-teal-500 flex-center">
      <div className="glass p-8 m-4 w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-white text-3xl font-bold mb-2" style={{ marginBottom: '12px',marginTop: '12px' }}>
            تسجيل دخول الإدارة
          </h1>
      
        </div>

        <form onSubmit={handleSubmit} className="flex-column gap-4">
          <div>
            <label className="text-white block mb-2"> رقم الموبايل  </label>
            <input
              type="text"
              name="mobileNumber"

              value={formData.mobileNumber}
              onChange={handleChange}
              placeholder="أدخل رقم الموبايل "
              className="input"
               
              style={{ textTransform: 'uppercase',marginBottom: '12px',marginTop: '12px' }}
              required
            />
          
          </div>

          <div>
            <label className="text-white block mb-2">كلمة المرور</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="أدخل كلمة المرور"
              className="input"
              style={{ textTransform: 'uppercase',marginBottom: '12px',marginTop: '12px' }}
              
              required
            />
          </div>

          {error && (
            <div className="bg-red-500 bg-opacity-20 border border-red-500 rounded-lg p-3">
              <p className="text-white text-sm">{error}</p>
            </div>
          )}

          {successMessage && (
            <div className="bg-green-500 bg-opacity-20 border border-green-500 rounded-lg p-3">
              <p className="text-white text-sm">{successMessage}</p>
            </div>
            )}

          <button
            type="submit"
            className="btn btn-primary w-full"
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="flex-center gap-2">
                <div className="spinner"></div>
                <span>جاري تسجيل الدخول...</span>
              </div>
            ) : (
              'تسجيل الدخول'
            )}
          </button>
        
          <button
            type="button"
            className="btn btn-primary w-full"
            disabled={isLoading}
            onClick={handleResetPassword}  // ADDED: Reset password handler
          >
            {isLoading ? (
              <div className="flex-center gap-2"> {/* REVERTED: Back to your original working class */}
                <div className="spinner"></div>
                <span> { 'جاري ارسال لينك على التيليجرام...'}</span>
              </div>
            ) : (
                ' نسيت كلمة السر'
            )}
          </button>


        <div className="mt-6 p-4 glass-dark rounded-lg center1">
          <h3 className="text-white font-semibold mb-2  center1 my-margin-top-1">فيديو للشرح   :</h3>
            <div style={{ 
              width: '300px', 
              margin: '0 auto',  // Centers the div horizontally
              aspectRatio: '9/16'  // Maintains video aspect ratio
            }}>
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/0789daM8PG8"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ display: 'block' }}
              />
            </div>

          <h3 className="text-white font-semibold mb-2 center1 my-margin-top-1"> التيليجرام     :</h3>

          <button 
            type="button"
            onClick={handleOpenBot}
            style={{
              padding: '12px 24px',
              backgroundColor: '#0088cc',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '22px',
              fontWeight: 'bold'
            }}
          >
            اضغط للتواصل عبر التيليجرام
          </button>

        </div>

        
        </form>

  {/* ================== Footer ================== */}
<div 
  style={{
    marginTop: "30px",
    padding: "12px",
    textAlign: "center",
    color: "white",
    fontSize: "14px",
    opacity: 0.9,
    cursor: "pointer"
  }}
  onClick={() => {
    window.open("https://wa.me/201550834905", "_blank");
  }}
>
  تم التصميم بواسطة شركة التسنيم للبرمجيات
</div>
{/* =============================================== */}
 
      </div>
    </div>
  );
};

export default EntityLogin;